export default "__VITE_ASSET__ieUIPVsN__"